/**
 * Checks if the given param exists on the current page.
 * If it does, add it to the link we will redirect to,
 * otherwise return the original link.
 * @param link  route we are redirecting to
 * @param param param to check for
 * @returns
 */
const checkParam = (link: string, param: string) => {
  const location = new URL(document.location.href);
  const paramValue = location.searchParams.get(param);
  if (paramValue) {
    const linkUrl = new URL(link, document.location.href);
    linkUrl.searchParams.set(param, paramValue);
    return linkUrl.toString();
  }
  return link;
};

export default checkParam;
